import short from 'short-uuid'
import VueTypes from 'vue-types'

export default {
    props: {
        id: VueTypes.string.def(() => short.generate()),
    },
}
